export default __webpack_public_path__ + "static/media/image-7.03708566.png";